/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getMachine = /* GraphQL */ `
  query GetMachine($id: ID!) {
    getMachine(id: $id) {
      id
      Name
      Type
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      CustomerName
      CustomerMachineID
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      isAccept
      OilChangeDate
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      SamplingBy
      SamplingPlace
      AnalizeTypeGroup
      AnalizeType
      AnalizeSet
      AnalizeItems
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      Surplus
      Filter
      OfficeID
      Status
      LatestOrderNumber
      LatestOrderAt
      LatestOperatingTime
      LatestOperatingTimeUnit
      LatestOperatingTimeUnitText
      MountedMachineID
      MountPosition
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMachines = /* GraphQL */ `
  query ListMachines(
    $filter: ModelMachineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMachines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Name
        Type
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        CustomerName
        CustomerMachineID
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        isAccept
        OilChangeDate
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        SamplingBy
        SamplingPlace
        AnalizeTypeGroup
        AnalizeType
        AnalizeSet
        AnalizeItems
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        Surplus
        Filter
        OfficeID
        Status
        LatestOrderNumber
        LatestOrderAt
        LatestOperatingTime
        LatestOperatingTimeUnit
        LatestOperatingTimeUnitText
        MountedMachineID
        MountPosition
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getParts = /* GraphQL */ `
  query GetParts($id: ID!) {
    getParts(id: $id) {
      id
      Name
      MachineID
      CustomerPartsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPartss = /* GraphQL */ `
  query ListPartss(
    $filter: ModelPartsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPartss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Name
        MachineID
        CustomerPartsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMachineLog = /* GraphQL */ `
  query GetMachineLog($id: ID!) {
    getMachineLog(id: $id) {
      id
      MachineID
      Type
      Description
      Detail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMachineLogs = /* GraphQL */ `
  query ListMachineLogs(
    $filter: ModelMachineLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMachineLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        MachineID
        Type
        Description
        Detail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSample = /* GraphQL */ `
  query GetSample($id: ID!) {
    getSample(id: $id) {
      id
      SamplingAt
      SamplerName
      MachineID
      Name
      AnalizeTypeGroup
      AnalizeTypeGroupName
      CustomerName
      CustomerMachineID
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      ParentCustomerMachineID
      ParentEquipment
      ParentMakerID
      ParentMakerText
      ParentModelNumber
      ParentPurchasedDate
      ParentTotalOperatingTime
      ParentTotalOperatingTimeUnit
      ParentTotalOperatingTimeUnitText
      ParentSinceOverhaulTime
      ParentSinceOverhaulTimeUnit
      ParentSinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      HazardousMaterialsConfirmed
      TrackingNumber
      OilChangeDate
      isOilChange
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      OilCondition
      OilConditionText
      AnalizeType
      AnalizeTypeName
      AnalizeSet
      AnalizeSetName
      AnalizeItems
      AnalizeItemNames
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      StandardValueName
      Surplus
      Filter
      LatestOrderNumber
      OfficeID
      BottleCount
      ApplicationID
      Status
      Memo
      SamplingBy
      SamplingPlace
      MountPosition
      DeliveryPeriod
      Quantity
      Price
      Report
      Opinion
      SampleID
      SameCount
      Message
      Discount
      Tax
      Fee
      SampleNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSamples = /* GraphQL */ `
  query ListSamples(
    $filter: ModelSampleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSamples(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        SamplingAt
        SamplerName
        MachineID
        Name
        AnalizeTypeGroup
        AnalizeTypeGroupName
        CustomerName
        CustomerMachineID
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        ParentCustomerMachineID
        ParentEquipment
        ParentMakerID
        ParentMakerText
        ParentModelNumber
        ParentPurchasedDate
        ParentTotalOperatingTime
        ParentTotalOperatingTimeUnit
        ParentTotalOperatingTimeUnitText
        ParentSinceOverhaulTime
        ParentSinceOverhaulTimeUnit
        ParentSinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        HazardousMaterialsConfirmed
        TrackingNumber
        OilChangeDate
        isOilChange
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        OilCondition
        OilConditionText
        AnalizeType
        AnalizeTypeName
        AnalizeSet
        AnalizeSetName
        AnalizeItems
        AnalizeItemNames
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        StandardValueName
        Surplus
        Filter
        LatestOrderNumber
        OfficeID
        BottleCount
        ApplicationID
        Status
        Memo
        SamplingBy
        SamplingPlace
        MountPosition
        DeliveryPeriod
        Quantity
        Price
        Report
        Opinion
        SampleID
        SameCount
        Message
        Discount
        Tax
        Fee
        SampleNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApplication = /* GraphQL */ `
  query GetApplication($id: ID!) {
    getApplication(id: $id) {
      id
      OrderNumber
      OfficeID
      AnalizeTypeCategory
      Name
      RepCompanyID
      RepOfficeID
      RepEmployeeID
      RepCompany
      RepOffice
      RepDept
      RepPIC
      DelvCompanyID
      DelvOfficeID
      DelvEmployeeID
      DelvCompany
      DelvOffice
      DelvDept
      DelvPIC
      DelvType
      DelvMailTo
      DelivMailCC
      Observation
      PayCompanyID
      PayOfficeID
      PayEmployeeID
      PayCompany
      PayOffice
      PayDept
      PayPIC
      Status
      CustomerOrderNumber
      Shipping
      OrdererID
      OrdererCompanyName
      OrdererOfficeName
      OrdererName
      CustomRepName
      SampleCount
      Price
      Discount
      Fee
      Type
      hasSurplus
      OrdeAt
      IssuedAt
      ValidityAt
      QuoteNumber
      Memo
      Message
      sortKey
      createdAt
      Samples {
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listApplications = /* GraphQL */ `
  query ListApplications(
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        OrderNumber
        OfficeID
        AnalizeTypeCategory
        Name
        RepCompanyID
        RepOfficeID
        RepEmployeeID
        RepCompany
        RepOffice
        RepDept
        RepPIC
        DelvCompanyID
        DelvOfficeID
        DelvEmployeeID
        DelvCompany
        DelvOffice
        DelvDept
        DelvPIC
        DelvType
        DelvMailTo
        DelivMailCC
        Observation
        PayCompanyID
        PayOfficeID
        PayEmployeeID
        PayCompany
        PayOffice
        PayDept
        PayPIC
        Status
        CustomerOrderNumber
        Shipping
        OrdererID
        OrdererCompanyName
        OrdererOfficeName
        OrdererName
        CustomRepName
        SampleCount
        Price
        Discount
        Fee
        Type
        hasSurplus
        OrdeAt
        IssuedAt
        ValidityAt
        QuoteNumber
        Memo
        Message
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCode = /* GraphQL */ `
  query GetCode($id: ID!) {
    getCode(id: $id) {
      id
      CodeType
      Text
      Value
      Order
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCodes = /* GraphQL */ `
  query ListCodes(
    $filter: ModelCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        CodeType
        Text
        Value
        Order
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeItem = /* GraphQL */ `
  query GetAnalizeItem($id: ID!) {
    getAnalizeItem(id: $id) {
      id
      AnalizeType
      Text
      Value
      Price
      Require
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeItems = /* GraphQL */ `
  query ListAnalizeItems(
    $filter: ModelAnalizeItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        AnalizeType
        Text
        Value
        Price
        Require
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeItemSub = /* GraphQL */ `
  query GetAnalizeItemSub($id: ID!) {
    getAnalizeItemSub(id: $id) {
      id
      AnalizeType
      Parent
      Text
      Value
      Price
      Require
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeItemSubs = /* GraphQL */ `
  query ListAnalizeItemSubs(
    $filter: ModelAnalizeItemSubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeItemSubs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        AnalizeType
        Parent
        Text
        Value
        Price
        Require
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeItemForCompany = /* GraphQL */ `
  query GetAnalizeItemForCompany($id: ID!) {
    getAnalizeItemForCompany(id: $id) {
      id
      CompanyID
      Value
      Text
      CustomValue
      CustomText
      Price
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeItemForCompanys = /* GraphQL */ `
  query ListAnalizeItemForCompanys(
    $filter: ModelAnalizeItemForCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeItemForCompanys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        Value
        Text
        CustomValue
        CustomText
        Price
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeSet = /* GraphQL */ `
  query GetAnalizeSet($id: ID!) {
    getAnalizeSet(id: $id) {
      id
      Company
      AnalizeType
      Text
      Value
      Price
      Require
      AnalizeItems
      AnalizeItemNames
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeSets = /* GraphQL */ `
  query ListAnalizeSets(
    $filter: ModelAnalizeSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Company
        AnalizeType
        Text
        Value
        Price
        Require
        AnalizeItems
        AnalizeItemNames
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeType = /* GraphQL */ `
  query GetAnalizeType($id: ID!) {
    getAnalizeType(id: $id) {
      id
      AnalizeTypeGroup
      Value
      Text
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeTypes = /* GraphQL */ `
  query ListAnalizeTypes(
    $filter: ModelAnalizeTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        AnalizeTypeGroup
        Value
        Text
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnalizeTypeGroup = /* GraphQL */ `
  query GetAnalizeTypeGroup($id: ID!) {
    getAnalizeTypeGroup(id: $id) {
      id
      AnalizeTypeCategory
      Value
      Text
      Order
      Code
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalizeTypeGroups = /* GraphQL */ `
  query ListAnalizeTypeGroups(
    $filter: ModelAnalizeTypeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalizeTypeGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeTypeCategory
        Value
        Text
        Order
        Code
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOilType = /* GraphQL */ `
  query GetOilType($id: ID!) {
    getOilType(id: $id) {
      id
      OilCategory
      Value
      Text
      isHazardousMaterials
      isAccept
      Order
      Description
      Properties
      Caution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOilTypes = /* GraphQL */ `
  query ListOilTypes(
    $filter: ModelOilTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOilTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        OilCategory
        Value
        Text
        isHazardousMaterials
        isAccept
        Order
        Description
        Properties
        Caution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStandardValue = /* GraphQL */ `
  query GetStandardValue($id: ID!) {
    getStandardValue(id: $id) {
      id
      OfficeID
      AnalizeType
      Text
      Value
      StandardValue
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStandardValues = /* GraphQL */ `
  query ListStandardValues(
    $filter: ModelStandardValueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStandardValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        OfficeID
        AnalizeType
        Text
        Value
        StandardValue
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      CompanyID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      RepresentPosition
      PIC
      PICDept
      PICContact
      Ratio
      PaymentCompanyID
      PaymentOfficeID
      PaymenyType
      Rounding
      Taxation
      AnalizeTypeGroup
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        CompanyID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        RepresentPosition
        PIC
        PICDept
        PICContact
        Ratio
        PaymentCompanyID
        PaymentOfficeID
        PaymenyType
        Rounding
        Taxation
        AnalizeTypeGroup
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOffice = /* GraphQL */ `
  query GetOffice($id: ID!) {
    getOffice(id: $id) {
      id
      CompanyID
      CompanyName
      OfficeID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      PICID
      PIC
      PICDept
      PICContact
      PICemail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOffices = /* GraphQL */ `
  query ListOffices(
    $filter: ModelOfficeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOffices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        CompanyID
        CompanyName
        OfficeID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        PICID
        PIC
        PICDept
        PICContact
        PICemail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      EmployeeID
      CompanyID
      OfficeID
      Name
      NameKana
      CompanyName
      OfficeName
      Tel
      Mobile
      FAX
      DeptName
      Position
      email
      Permission
      UserPoolID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        EmployeeID
        CompanyID
        OfficeID
        Name
        NameKana
        CompanyName
        OfficeName
        Tel
        Mobile
        FAX
        DeptName
        Position
        email
        Permission
        UserPoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInformation = /* GraphQL */ `
  query GetInformation($id: ID!, $Order: String!) {
    getInformation(id: $id, Order: $Order) {
      id
      Type
      Message
      Detail
      NoticeFrom
      NoticeTo
      Order
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInformations = /* GraphQL */ `
  query ListInformations(
    $id: ID
    $Order: ModelStringKeyConditionInput
    $filter: ModelInformationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInformations(
      id: $id
      Order: $Order
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Type
        Message
        Detail
        NoticeFrom
        NoticeTo
        Order
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFAQ = /* GraphQL */ `
  query GetFAQ($id: ID!, $Order: String!) {
    getFAQ(id: $id, Order: $Order) {
      id
      Category
      Question
      Answer
      isActive
      Order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFAQs = /* GraphQL */ `
  query ListFAQs(
    $id: ID
    $Order: ModelStringKeyConditionInput
    $filter: ModelFAQFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFAQs(
      id: $id
      Order: $Order
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Category
        Question
        Answer
        isActive
        Order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConfigure = /* GraphQL */ `
  query GetConfigure($id: ID!) {
    getConfigure(id: $id) {
      id
      Key
      Value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listConfigures = /* GraphQL */ `
  query ListConfigures(
    $filter: ModelConfigureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConfigures(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Key
        Value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOutbox = /* GraphQL */ `
  query GetOutbox($id: ID!) {
    getOutbox(id: $id) {
      id
      Type
      From
      To
      CC
      Subject
      Body
      Status
      Sending
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOutboxs = /* GraphQL */ `
  query ListOutboxs(
    $filter: ModelOutboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboxs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Type
        From
        To
        CC
        Subject
        Body
        Status
        Sending
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      Name
      Description
      Discount
      From
      To
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Name
        Description
        Discount
        From
        To
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHolder = /* GraphQL */ `
  query GetHolder($id: ID!) {
    getHolder(id: $id) {
      id
      Value
      Text
      TextEn
      Nickname
      Price
      Require
      TestingMethod
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHolders = /* GraphQL */ `
  query ListHolders(
    $filter: ModelHolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHolders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Value
        Text
        TextEn
        Nickname
        Price
        Require
        TestingMethod
        Description
        at1001
        at1002
        at1003
        at1004
        at1005
        at1101
        at1102
        at1103
        at1104
        at1105
        at2001
        at3001
        at3002
        at3003
        at3101
        at3102
        at3103
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProtocol = /* GraphQL */ `
  query GetProtocol($id: ID!) {
    getProtocol(id: $id) {
      id
      Value
      Text
      Price
      Holders
      HolderNames
      Require
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProtocols = /* GraphQL */ `
  query ListProtocols(
    $filter: ModelProtocolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProtocols(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Value
        Text
        Price
        Holders
        HolderNames
        Require
        Description
        at1001
        at1002
        at1003
        at1004
        at1005
        at1101
        at1102
        at1103
        at1104
        at1105
        at2001
        at3001
        at3002
        at3003
        at3101
        at3102
        at3103
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeliverables = /* GraphQL */ `
  query GetDeliverables($id: ID!) {
    getDeliverables(id: $id) {
      id
      ApplicationID
      OrderNumber
      CompanyID
      OfficeID
      Company
      Office
      Dept
      PIC
      email
      MachineID
      SampleRecordID
      SampleID
      SampleNumber
      SampleName
      ReportNumber
      ReportVersion
      InReviewReportNumber
      InReviewReportVersion
      FileName
      Type
      DownloadAt
      DownloadUser
      DownloadCount
      DownloadDeadline
      Status
      Memo
      isAdcive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeliverabless = /* GraphQL */ `
  query ListDeliverabless(
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliverabless(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDownLoadHistory = /* GraphQL */ `
  query GetDownLoadHistory($id: ID!) {
    getDownLoadHistory(id: $id) {
      id
      DeliverablesID
      DownloadAt
      DownloadUser
      Type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDownLoadHistorys = /* GraphQL */ `
  query ListDownLoadHistorys(
    $filter: ModelDownLoadHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDownLoadHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        DeliverablesID
        DownloadAt
        DownloadUser
        Type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const machineByOffice = /* GraphQL */ `
  query MachineByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelMachineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    machineByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Name
        Type
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        CustomerName
        CustomerMachineID
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        isAccept
        OilChangeDate
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        SamplingBy
        SamplingPlace
        AnalizeTypeGroup
        AnalizeType
        AnalizeSet
        AnalizeItems
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        Surplus
        Filter
        OfficeID
        Status
        LatestOrderNumber
        LatestOrderAt
        LatestOperatingTime
        LatestOperatingTimeUnit
        LatestOperatingTimeUnitText
        MountedMachineID
        MountPosition
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mountedMachine = /* GraphQL */ `
  query MountedMachine(
    $MountedMachineID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelMachineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mountedMachine(
      MountedMachineID: $MountedMachineID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Name
        Type
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        CustomerName
        CustomerMachineID
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        isAccept
        OilChangeDate
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        SamplingBy
        SamplingPlace
        AnalizeTypeGroup
        AnalizeType
        AnalizeSet
        AnalizeItems
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        Surplus
        Filter
        OfficeID
        Status
        LatestOrderNumber
        LatestOrderAt
        LatestOperatingTime
        LatestOperatingTimeUnit
        LatestOperatingTimeUnitText
        MountedMachineID
        MountPosition
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const partsByMachine = /* GraphQL */ `
  query PartsByMachine(
    $MachineID: ID
    $CustomerPartsID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPartsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    partsByMachine(
      MachineID: $MachineID
      CustomerPartsID: $CustomerPartsID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Name
        MachineID
        CustomerPartsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const machineLogsByMachine = /* GraphQL */ `
  query MachineLogsByMachine(
    $MachineID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMachineLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    machineLogsByMachine(
      MachineID: $MachineID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        MachineID
        Type
        Description
        Detail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const samplesByApplication = /* GraphQL */ `
  query SamplesByApplication(
    $ApplicationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSampleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    samplesByApplication(
      ApplicationID: $ApplicationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SamplingAt
        SamplerName
        MachineID
        Name
        AnalizeTypeGroup
        AnalizeTypeGroupName
        CustomerName
        CustomerMachineID
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        ParentCustomerMachineID
        ParentEquipment
        ParentMakerID
        ParentMakerText
        ParentModelNumber
        ParentPurchasedDate
        ParentTotalOperatingTime
        ParentTotalOperatingTimeUnit
        ParentTotalOperatingTimeUnitText
        ParentSinceOverhaulTime
        ParentSinceOverhaulTimeUnit
        ParentSinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        HazardousMaterialsConfirmed
        TrackingNumber
        OilChangeDate
        isOilChange
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        OilCondition
        OilConditionText
        AnalizeType
        AnalizeTypeName
        AnalizeSet
        AnalizeSetName
        AnalizeItems
        AnalizeItemNames
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        StandardValueName
        Surplus
        Filter
        LatestOrderNumber
        OfficeID
        BottleCount
        ApplicationID
        Status
        Memo
        SamplingBy
        SamplingPlace
        MountPosition
        DeliveryPeriod
        Quantity
        Price
        Report
        Opinion
        SampleID
        SameCount
        Message
        Discount
        Tax
        Fee
        SampleNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const samplesByOffice = /* GraphQL */ `
  query SamplesByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelSampleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    samplesByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SamplingAt
        SamplerName
        MachineID
        Name
        AnalizeTypeGroup
        AnalizeTypeGroupName
        CustomerName
        CustomerMachineID
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        ParentCustomerMachineID
        ParentEquipment
        ParentMakerID
        ParentMakerText
        ParentModelNumber
        ParentPurchasedDate
        ParentTotalOperatingTime
        ParentTotalOperatingTimeUnit
        ParentTotalOperatingTimeUnitText
        ParentSinceOverhaulTime
        ParentSinceOverhaulTimeUnit
        ParentSinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        HazardousMaterialsConfirmed
        TrackingNumber
        OilChangeDate
        isOilChange
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        OilCondition
        OilConditionText
        AnalizeType
        AnalizeTypeName
        AnalizeSet
        AnalizeSetName
        AnalizeItems
        AnalizeItemNames
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        StandardValueName
        Surplus
        Filter
        LatestOrderNumber
        OfficeID
        BottleCount
        ApplicationID
        Status
        Memo
        SamplingBy
        SamplingPlace
        MountPosition
        DeliveryPeriod
        Quantity
        Price
        Report
        Opinion
        SampleID
        SameCount
        Message
        Discount
        Tax
        Fee
        SampleNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const samplesByMachine = /* GraphQL */ `
  query SamplesByMachine(
    $MachineID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSampleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    samplesByMachine(
      MachineID: $MachineID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SamplingAt
        SamplerName
        MachineID
        Name
        AnalizeTypeGroup
        AnalizeTypeGroupName
        CustomerName
        CustomerMachineID
        MachineCategory
        MachineCategoryText
        MachineType
        MachineTypeText
        Equipment
        MakerID
        MakerText
        ModelNumber
        PurchasedDate
        SystemOil
        SystemOilUnit
        SystemOilUnitText
        MachineMemo
        TotalOperatingTime
        TotalOperatingTimeUnit
        TotalOperatingTimeUnitText
        OperatingTime
        OperatingTimeUnit
        OperatingTimeUnitText
        OverhaulDate
        SinceOverhaulTime
        SinceOverhaulTimeUnit
        SinceOverhaulTimeUnitText
        ParentCustomerMachineID
        ParentEquipment
        ParentMakerID
        ParentMakerText
        ParentModelNumber
        ParentPurchasedDate
        ParentTotalOperatingTime
        ParentTotalOperatingTimeUnit
        ParentTotalOperatingTimeUnitText
        ParentSinceOverhaulTime
        ParentSinceOverhaulTimeUnit
        ParentSinceOverhaulTimeUnitText
        OilmakerID
        OilmakerText
        OilModelNumber
        OilGrade
        OilGradeText
        OilTypeCategory
        OilTypeCategoryText
        OilType
        OilTypeText
        OilProperty
        OilPropertyText
        isHazardousMaterials
        HazardousMaterialsDetail
        HazardousMaterialsConfirmed
        TrackingNumber
        OilChangeDate
        isOilChange
        OilChange
        OilChangeUnit
        OilChangeUnitText
        OilUsageTime
        OilUsageTimeUnit
        OilUsageTimeUnitText
        UseFilter
        FilterUsageTime
        FilterUsageTimeUnit
        FilterUsageTimeUnitText
        OilCondition
        OilConditionText
        AnalizeType
        AnalizeTypeName
        AnalizeSet
        AnalizeSetName
        AnalizeItems
        AnalizeItemNames
        AnalizeItemSub
        AnalizePurpose
        StandardValue
        StandardValueName
        Surplus
        Filter
        LatestOrderNumber
        OfficeID
        BottleCount
        ApplicationID
        Status
        Memo
        SamplingBy
        SamplingPlace
        MountPosition
        DeliveryPeriod
        Quantity
        Price
        Report
        Opinion
        SampleID
        SameCount
        Message
        Discount
        Tax
        Fee
        SampleNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const applicationsByOffice = /* GraphQL */ `
  query ApplicationsByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    applicationsByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OrderNumber
        OfficeID
        AnalizeTypeCategory
        Name
        RepCompanyID
        RepOfficeID
        RepEmployeeID
        RepCompany
        RepOffice
        RepDept
        RepPIC
        DelvCompanyID
        DelvOfficeID
        DelvEmployeeID
        DelvCompany
        DelvOffice
        DelvDept
        DelvPIC
        DelvType
        DelvMailTo
        DelivMailCC
        Observation
        PayCompanyID
        PayOfficeID
        PayEmployeeID
        PayCompany
        PayOffice
        PayDept
        PayPIC
        Status
        CustomerOrderNumber
        Shipping
        OrdererID
        OrdererCompanyName
        OrdererOfficeName
        OrdererName
        CustomRepName
        SampleCount
        Price
        Discount
        Fee
        Type
        hasSurplus
        OrdeAt
        IssuedAt
        ValidityAt
        QuoteNumber
        Memo
        Message
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const applicationsByOrderNum = /* GraphQL */ `
  query ApplicationsByOrderNum(
    $OrderNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    applicationsByOrderNum(
      OrderNumber: $OrderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OrderNumber
        OfficeID
        AnalizeTypeCategory
        Name
        RepCompanyID
        RepOfficeID
        RepEmployeeID
        RepCompany
        RepOffice
        RepDept
        RepPIC
        DelvCompanyID
        DelvOfficeID
        DelvEmployeeID
        DelvCompany
        DelvOffice
        DelvDept
        DelvPIC
        DelvType
        DelvMailTo
        DelivMailCC
        Observation
        PayCompanyID
        PayOfficeID
        PayEmployeeID
        PayCompany
        PayOffice
        PayDept
        PayPIC
        Status
        CustomerOrderNumber
        Shipping
        OrdererID
        OrdererCompanyName
        OrdererOfficeName
        OrdererName
        CustomRepName
        SampleCount
        Price
        Discount
        Fee
        Type
        hasSurplus
        OrdeAt
        IssuedAt
        ValidityAt
        QuoteNumber
        Memo
        Message
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedlistApplications = /* GraphQL */ `
  query SortedlistApplications(
    $Type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedlistApplications(
      Type: $Type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OrderNumber
        OfficeID
        AnalizeTypeCategory
        Name
        RepCompanyID
        RepOfficeID
        RepEmployeeID
        RepCompany
        RepOffice
        RepDept
        RepPIC
        DelvCompanyID
        DelvOfficeID
        DelvEmployeeID
        DelvCompany
        DelvOffice
        DelvDept
        DelvPIC
        DelvType
        DelvMailTo
        DelivMailCC
        Observation
        PayCompanyID
        PayOfficeID
        PayEmployeeID
        PayCompany
        PayOffice
        PayDept
        PayPIC
        Status
        CustomerOrderNumber
        Shipping
        OrdererID
        OrdererCompanyName
        OrdererOfficeName
        OrdererName
        CustomRepName
        SampleCount
        Price
        Discount
        Fee
        Type
        hasSurplus
        OrdeAt
        IssuedAt
        ValidityAt
        QuoteNumber
        Memo
        Message
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedApplicationsBySortKey = /* GraphQL */ `
  query SortedApplicationsBySortKey(
    $sortKey: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedApplicationsBySortKey(
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OrderNumber
        OfficeID
        AnalizeTypeCategory
        Name
        RepCompanyID
        RepOfficeID
        RepEmployeeID
        RepCompany
        RepOffice
        RepDept
        RepPIC
        DelvCompanyID
        DelvOfficeID
        DelvEmployeeID
        DelvCompany
        DelvOffice
        DelvDept
        DelvPIC
        DelvType
        DelvMailTo
        DelivMailCC
        Observation
        PayCompanyID
        PayOfficeID
        PayEmployeeID
        PayCompany
        PayOffice
        PayDept
        PayPIC
        Status
        CustomerOrderNumber
        Shipping
        OrdererID
        OrdererCompanyName
        OrdererOfficeName
        OrdererName
        CustomRepName
        SampleCount
        Price
        Discount
        Fee
        Type
        hasSurplus
        OrdeAt
        IssuedAt
        ValidityAt
        QuoteNumber
        Memo
        Message
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const codesByType = /* GraphQL */ `
  query CodesByType(
    $CodeType: String
    $sortDirection: ModelSortDirection
    $filter: ModelCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    codesByType(
      CodeType: $CodeType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CodeType
        Text
        Value
        Order
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedCodesByType = /* GraphQL */ `
  query SortedCodesByType(
    $CodeType: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedCodesByType(
      CodeType: $CodeType
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CodeType
        Text
        Value
        Order
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemByType = /* GraphQL */ `
  query AnalizeItemByType(
    $AnalizeType: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemByType(
      AnalizeType: $AnalizeType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Text
        Value
        Price
        Require
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedAnalizeItemByType = /* GraphQL */ `
  query SortedAnalizeItemByType(
    $AnalizeType: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedAnalizeItemByType(
      AnalizeType: $AnalizeType
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Text
        Value
        Price
        Require
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemByKey = /* GraphQL */ `
  query AnalizeItemByKey(
    $Value: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemByKey(
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Text
        Value
        Price
        Require
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemSubByType = /* GraphQL */ `
  query AnalizeItemSubByType(
    $AnalizeType: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemSubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemSubByType(
      AnalizeType: $AnalizeType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Parent
        Text
        Value
        Price
        Require
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemSubByParent = /* GraphQL */ `
  query AnalizeItemSubByParent(
    $Parent: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemSubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemSubByParent(
      Parent: $Parent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Parent
        Text
        Value
        Price
        Require
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemSubByKey = /* GraphQL */ `
  query AnalizeItemSubByKey(
    $Value: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemSubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemSubByKey(
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeType
        Parent
        Text
        Value
        Price
        Require
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeItemByCompany = /* GraphQL */ `
  query AnalizeItemByCompany(
    $CompanyID: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeItemForCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeItemByCompany(
      CompanyID: $CompanyID
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        Value
        Text
        CustomValue
        CustomText
        Price
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeSetByType = /* GraphQL */ `
  query AnalizeSetByType(
    $AnalizeType: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeSetByType(
      AnalizeType: $AnalizeType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Company
        AnalizeType
        Text
        Value
        Price
        Require
        AnalizeItems
        AnalizeItemNames
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedAnalizeSetByType = /* GraphQL */ `
  query SortedAnalizeSetByType(
    $AnalizeType: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedAnalizeSetByType(
      AnalizeType: $AnalizeType
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Company
        AnalizeType
        Text
        Value
        Price
        Require
        AnalizeItems
        AnalizeItemNames
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeSetByKey = /* GraphQL */ `
  query AnalizeSetByKey(
    $Value: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeSetByKey(
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Company
        AnalizeType
        Text
        Value
        Price
        Require
        AnalizeItems
        AnalizeItemNames
        Description
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeTypeByGroup = /* GraphQL */ `
  query AnalizeTypeByGroup(
    $AnalizeTypeGroup: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeTypeByGroup(
      AnalizeTypeGroup: $AnalizeTypeGroup
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeTypeGroup
        Value
        Text
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analizeTypeGroupByCategory = /* GraphQL */ `
  query AnalizeTypeGroupByCategory(
    $AnalizeTypeCategory: String
    $Order: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalizeTypeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analizeTypeGroupByCategory(
      AnalizeTypeCategory: $AnalizeTypeCategory
      Order: $Order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AnalizeTypeCategory
        Value
        Text
        Order
        Code
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const oilTypeByCategory = /* GraphQL */ `
  query OilTypeByCategory(
    $OilCategory: String
    $Order: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOilTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    oilTypeByCategory(
      OilCategory: $OilCategory
      Order: $Order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OilCategory
        Value
        Text
        isHazardousMaterials
        isAccept
        Order
        Description
        Properties
        Caution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const standardValueByOffice = /* GraphQL */ `
  query StandardValueByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelStandardValueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    standardValueByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OfficeID
        AnalizeType
        Text
        Value
        StandardValue
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedStandardValueByOffice = /* GraphQL */ `
  query SortedStandardValueByOffice(
    $OfficeID: String
    $Value: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStandardValueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedStandardValueByOffice(
      OfficeID: $OfficeID
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        OfficeID
        AnalizeType
        Text
        Value
        StandardValue
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companyByKey = /* GraphQL */ `
  query CompanyByKey(
    $CompanyID: String
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyByKey(
      CompanyID: $CompanyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        RepresentPosition
        PIC
        PICDept
        PICContact
        Ratio
        PaymentCompanyID
        PaymentOfficeID
        PaymenyType
        Rounding
        Taxation
        AnalizeTypeGroup
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedCompanylistAnActive = /* GraphQL */ `
  query SortedCompanylistAnActive(
    $isActive: String
    $CompanyID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedCompanylistAnActive(
      isActive: $isActive
      CompanyID: $CompanyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        RepresentPosition
        PIC
        PICDept
        PICContact
        Ratio
        PaymentCompanyID
        PaymentOfficeID
        PaymenyType
        Rounding
        Taxation
        AnalizeTypeGroup
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const officeByKey = /* GraphQL */ `
  query OfficeByKey(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelOfficeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    officeByKey(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        CompanyName
        OfficeID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        PICID
        PIC
        PICDept
        PICContact
        PICemail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const officeByCompany = /* GraphQL */ `
  query OfficeByCompany(
    $CompanyID: String
    $OfficeID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOfficeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    officeByCompany(
      CompanyID: $CompanyID
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        CompanyID
        CompanyName
        OfficeID
        Name
        NameKana
        Nickname
        Country
        Pref
        Zip
        Address1
        Address2
        Address3
        Tel
        FAX
        Represent
        PICID
        PIC
        PICDept
        PICContact
        PICemail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByKey = /* GraphQL */ `
  query EmployeeByKey(
    $EmployeeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByKey(
      EmployeeID: $EmployeeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        EmployeeID
        CompanyID
        OfficeID
        Name
        NameKana
        CompanyName
        OfficeName
        Tel
        Mobile
        FAX
        DeptName
        Position
        email
        Permission
        UserPoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByUserPool = /* GraphQL */ `
  query EmployeeByUserPool(
    $UserPoolID: String
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByUserPool(
      UserPoolID: $UserPoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        EmployeeID
        CompanyID
        OfficeID
        Name
        NameKana
        CompanyName
        OfficeName
        Tel
        Mobile
        FAX
        DeptName
        Position
        email
        Permission
        UserPoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByOffice = /* GraphQL */ `
  query EmployeeByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        EmployeeID
        CompanyID
        OfficeID
        Name
        NameKana
        CompanyName
        OfficeName
        Tel
        Mobile
        FAX
        DeptName
        Position
        email
        Permission
        UserPoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByEmail = /* GraphQL */ `
  query EmployeeByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        EmployeeID
        CompanyID
        OfficeID
        Name
        NameKana
        CompanyName
        OfficeName
        Tel
        Mobile
        FAX
        DeptName
        Position
        email
        Permission
        UserPoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedlistInformations = /* GraphQL */ `
  query SortedlistInformations(
    $isActive: String
    $Order: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedlistInformations(
      isActive: $isActive
      Order: $Order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Type
        Message
        Detail
        NoticeFrom
        NoticeTo
        Order
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedlistFAQs = /* GraphQL */ `
  query SortedlistFAQs(
    $isActive: String
    $Order: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFAQFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedlistFAQs(
      isActive: $isActive
      Order: $Order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Category
        Question
        Answer
        isActive
        Order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const configureByKey = /* GraphQL */ `
  query ConfigureByKey(
    $Key: String
    $sortDirection: ModelSortDirection
    $filter: ModelConfigureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    configureByKey(
      Key: $Key
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Key
        Value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedlistOutBox = /* GraphQL */ `
  query SortedlistOutBox(
    $Type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedlistOutBox(
      Type: $Type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Type
        From
        To
        CC
        Subject
        Body
        Status
        Sending
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sortedlistCampaign = /* GraphQL */ `
  query SortedlistCampaign(
    $isActive: String
    $To: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sortedlistCampaign(
      isActive: $isActive
      To: $To
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Name
        Description
        Discount
        From
        To
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const holderByKey = /* GraphQL */ `
  query HolderByKey(
    $Value: String
    $sortDirection: ModelSortDirection
    $filter: ModelHolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    holderByKey(
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Value
        Text
        TextEn
        Nickname
        Price
        Require
        TestingMethod
        Description
        at1001
        at1002
        at1003
        at1004
        at1005
        at1101
        at1102
        at1103
        at1104
        at1105
        at2001
        at3001
        at3002
        at3003
        at3101
        at3102
        at3103
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const protocolByKey = /* GraphQL */ `
  query ProtocolByKey(
    $Value: String
    $sortDirection: ModelSortDirection
    $filter: ModelProtocolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    protocolByKey(
      Value: $Value
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Value
        Text
        Price
        Holders
        HolderNames
        Require
        Description
        at1001
        at1002
        at1003
        at1004
        at1005
        at1101
        at1102
        at1103
        at1104
        at1105
        at2001
        at3001
        at3002
        at3003
        at3101
        at3102
        at3103
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByApplication = /* GraphQL */ `
  query DeliverablesByApplication(
    $ApplicationID: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByApplication(
      ApplicationID: $ApplicationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByOrderNumber = /* GraphQL */ `
  query DeliverablesByOrderNumber(
    $OrderNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByOrderNumber(
      OrderNumber: $OrderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByReportNumber = /* GraphQL */ `
  query DeliverablesByReportNumber(
    $ReportNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByReportNumber(
      ReportNumber: $ReportNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByInReviewReportNumber = /* GraphQL */ `
  query DeliverablesByInReviewReportNumber(
    $InReviewReportNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByInReviewReportNumber(
      InReviewReportNumber: $InReviewReportNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesBySample = /* GraphQL */ `
  query DeliverablesBySample(
    $SampleRecordID: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesBySample(
      SampleRecordID: $SampleRecordID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByOffice = /* GraphQL */ `
  query DeliverablesByOffice(
    $OfficeID: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByOffice(
      OfficeID: $OfficeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliverablesByMachine = /* GraphQL */ `
  query DeliverablesByMachine(
    $MachineID: String
    $sortDirection: ModelSortDirection
    $filter: ModelDeliverablesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliverablesByMachine(
      MachineID: $MachineID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ApplicationID
        OrderNumber
        CompanyID
        OfficeID
        Company
        Office
        Dept
        PIC
        email
        MachineID
        SampleRecordID
        SampleID
        SampleNumber
        SampleName
        ReportNumber
        ReportVersion
        InReviewReportNumber
        InReviewReportVersion
        FileName
        Type
        DownloadAt
        DownloadUser
        DownloadCount
        DownloadDeadline
        Status
        Memo
        isAdcive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const downloadHistoryByDeliverables = /* GraphQL */ `
  query DownloadHistoryByDeliverables(
    $DeliverablesID: String
    $sortDirection: ModelSortDirection
    $filter: ModelDownLoadHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    downloadHistoryByDeliverables(
      DeliverablesID: $DeliverablesID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        DeliverablesID
        DownloadAt
        DownloadUser
        Type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const downloadHistoryByUser = /* GraphQL */ `
  query DownloadHistoryByUser(
    $DownloadUser: String
    $sortDirection: ModelSortDirection
    $filter: ModelDownLoadHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    downloadHistoryByUser(
      DownloadUser: $DownloadUser
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        DeliverablesID
        DownloadAt
        DownloadUser
        Type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
